import { cn } from '@shared/shared-utils';
import { type FC, type PropsWithChildren } from 'react';

type Properties = PropsWithChildren<{
  className?: string;
}>;

const Footnote: FC<Properties> = ({ children, className }: Properties) => {
  return (
    <p className={cn('text-[16px] text-wcw-grey', className)}>{children}</p>
  );
};

export { Footnote };
